import _ from 'lodash';
// eslint-disable-next-line import/no-extraneous-dependencies
import Big from 'big.js';

function sumOriginalTotal(items, discountTaxOrder) {
  let originalTotalPrice = Big(0);
  // Iterate over products to determine originalTotalPrice
  _.forEach(items, ({ basePrice, basePriceMult, mixAndMatch, quantity }) => {
    const adjustedBasePrice = mixAndMatch?.adjustedBasePrice || basePrice || 0;
    originalTotalPrice = originalTotalPrice.add(
      // Multiply basePrice by the tax mult to account for taxes in the menu or from POS for taxesFirst setting
      adjustedBasePrice.times(discountTaxOrder === 'taxesFirst' ? basePriceMult || 1 : 1).times(quantity)
    );
  });
  return originalTotalPrice;
}

const issueDiscountToCartRewards = (bogoCalcsData, bogoSpecial, discountTaxOrder, items, conditionsManager) => {
  const { discountToCart, specialId, specialName } = bogoSpecial;
  const rewardId = discountToCart?._id;
  let targetIndividualDiscountPercentage = Big(0);

  const originalTotalPrice = sumOriginalTotal(items, discountTaxOrder);
  const totalDiscount =
    discountToCart?.discountType === 'percentDiscount'
      ? originalTotalPrice.times(Big(discountToCart?.value ?? 0).div(100))
      : Big(discountToCart?.value);
  /*
    taking the total discount and dividing it by the cart total will leave
    you with the percentage of each product that needs to be discounted
   */
  if (originalTotalPrice.gt(0)) {
    targetIndividualDiscountPercentage = totalDiscount.div(originalTotalPrice);
  }

  if (targetIndividualDiscountPercentage.lt(0)) {
    return {};
  }

  // filter out products that have had their DTC reward defeated
  const itemsNotDefeatedByOtherRewards = _.filter(
    items,
    ({ key }) => !bogoCalcsData.defeatedDiscountToCartRewards?.[rewardId]?.[key]
  );

  /*
    when one or more product has it's DTC cart reward defeated, we need to
    take the same overall discount and spread it evenly across the remaining
    products so that the overall DTC value is preserved
   */
  const atleastOneProductRemainsUndefeated =
    itemsNotDefeatedByOtherRewards.length > 0 && itemsNotDefeatedByOtherRewards.length < items.length;

  if (atleastOneProductRemainsUndefeated) {
    const totalPriceMinusProductsWithRewards = sumOriginalTotal(itemsNotDefeatedByOtherRewards, discountTaxOrder);
    // here the targetIndividualDiscountPercentage will increase by some amount
    // so the discount will be larger for the remaining products
    if (totalPriceMinusProductsWithRewards.gt(0)) {
      targetIndividualDiscountPercentage = totalDiscount.div(totalPriceMinusProductsWithRewards);
    }
  }

  const discountToCartRewards = {};
  _.forEach(itemsNotDefeatedByOtherRewards, (item) => {
    const adjustedBasePrice = Big(item.mixAndMatch?.adjustedBasePrice || item.basePrice || 0);

    let discount = adjustedBasePrice
      .times(discountTaxOrder === 'taxesFirst' ? Big(item.basePriceMult || 1) : 1)
      .times(targetIndividualDiscountPercentage);

    /*
      if the defeated discounts end up stacking onto
      one or more products and the discount is too large
      we want to 0 out the product instead
      of over discounting a single product
    */
    if (discount.gt(adjustedBasePrice)) {
      discount = adjustedBasePrice;
    }

    const hasPreviousDTCReward = !!bogoCalcsData.discountToCartRewards?.[item.key]?.rewards?.[rewardId];
    const redemptionMultiplier = hasPreviousDTCReward
      ? bogoCalcsData.discountToCartRewards?.[item.key]?.rewards?.[rewardId]?.reward?.redemptionMultiplier
      : 0;

    const { discountStacking, stackingBehavior } = conditionsManager?.specialsSettings ?? {};
    discountToCartRewards[item.key] = {
      item,
      quantity: item.quantity,
      rewards: {
        [rewardId]: {
          quantity: item.quantity,
          reward: {
            _id: rewardId,
            dollarDiscount: Big(discount),
            discountToCart: { ...discountToCart },
            redemptionMultiplier: redemptionMultiplier + 1,
          },
          specialId,
          specialName,
          discountStacking,
          stackingBehavior,
        },
      },
    };
  });
  return discountToCartRewards;
};

export default issueDiscountToCartRewards;
